module.exports = __webpack_public_path__ + "static/media/aifc-logo-vertical.559b791e.png";